document.addEventListener('DOMContentLoaded', function() {
    console.log("teste 1");
    setTimeout(() => {
            
        const chatButton = document.querySelector("#gorgias-chat-container");
         
        if (chatButton) {
            console.log("chatButton");
            chatButton.style.display = 'none';
        }
        
        const showAndClickChat = function() {
            const chatButtonToShow = document.querySelector("#gorgias-chat-container");
            if (chatButtonToShow) {
                chatButtonToShow.style.display = '';
                chatButtonToShow.click();
            }
        };
        
        const mobileButtonId = 'custom-chat-link-mobile';
        if (!document.querySelector('#' + mobileButtonId)) {
            const mobileMenu = document.querySelector("#mobile-menu > div > div:nth-child(1) > div:nth-child(3) > ul.menu__linklist");
            if (mobileMenu) {
                const mobileLi = document.createElement('li');
                mobileLi.id = mobileButtonId;
                mobileLi.innerHTML = `<a class="menu__link-item fa fa-envelope" style="cursor: pointer;">Contact Us</a>`;
                mobileLi.querySelector('a').addEventListener('click', showAndClickChat);
                mobileMenu.appendChild(mobileLi);
            }
        }
        
        const footerButtonId = 'custom-chat-link-footer';
        if (!document.querySelector('#' + footerButtonId)) {
            const footerMenu = document.querySelector("#block-ce51f6df-e2af-4872-9fa7-1cd723c0a365 > div > ul");
            if (footerMenu) {
                const footerLi = document.createElement('li');
                footerLi.id = footerButtonId;
                footerLi.innerHTML = `<a class="footer__link-item link" style="cursor: pointer;">Chat with us!</a>`;
                footerLi.querySelector('a').addEventListener('click', showAndClickChat);
                footerMenu.appendChild(footerLi);
            }
        }
    }, 500);
});